import React, { useEffect, useState } from "react";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";
import { LookupManager, LookupFieldOption } from "./lookup-manager";
import AdminPortalAppService from "../../../application/platform/admin-portal/admin-portal-app-service";

const ServidoresFactory = () => {
    const [orgaos, setOrgaos] = useState<LookupFieldOption[]>([]);

    useEffect(() => {
        (async () => {
            const result = await AdminPortalAppService.listOrgaos();
            setOrgaos(result || []);
        })();
    }, []);

    return (
        <BaseInternalFormFactory pageTitle={"Servidores"}>
            <LookupManager
                title="Servidores"
                fields={[
                    { key: "idOrgao", label: "Órgão", type: "select", required: true, options: orgaos },
                    { key: "nomServidor", label: "Nome do Servidor", required: true, maxLength: 200 },
                    { key: "cargo", label: "Cargo", required: true, maxLength: 60 }
                ]}
                listFn={AdminPortalAppService.listServidores}
                addUpdateFn={AdminPortalAppService.addUpdateServidor}
                variant="standalone"
            />
        </BaseInternalFormFactory>
    );
};

export default ServidoresFactory;
